import { render, staticRenderFns } from "./organization-control-form.vue?vue&type=template&id=86cc27fa&"
import script from "./organization-control-form.vue?vue&type=script&lang=js&"
export * from "./organization-control-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports